<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M54.69 20.92l-7.64-7.49A1.5 1.5 0 0045 15.57L50.49 21H11a2 2 0 00-2 2v30a1.5 1.5 0 003 0V24h38.27l-5.34 5.45a1.5 1.5 0 000 2.12 1.5 1.5 0 002.12 0l7.65-7.81a2 2 0 00-.01-2.84z"/></svg>